// Drives `LiveRegion`'s `aria-live="polite"` text (docs/06-ux-rules.md
// "Live region" / P10 D5) — e.g. "Resolved — showing {name}" on
// auto-advance, look-back open/close. No `aria-live` component exists
// elsewhere in this repo (P10) — net new.
import { useCallback, useRef, useState } from 'react'

export interface UseLiveAnnouncerResult {
  message: string
  announce: (text: string) => void
}

export function useLiveAnnouncer(): UseLiveAnnouncerResult {
  const [message, setMessage] = useState('')
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>()

  const announce = useCallback((text: string) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    // Many screen readers don't re-announce `aria-live` text that hasn't
    // changed (e.g. two resolves in a row both landing on "showing Jane
    // Doe") — clearing first, then setting the real text on the next tick,
    // forces a DOM mutation every time so the announcement always fires.
    setMessage('')
    timeoutRef.current = setTimeout(() => setMessage(text), 0)
  }, [])

  return { message, announce }
}
